import { accountApi } from "../../config/apiConfig";
import { LocationTypeOption } from "../../types/onboarding";

// GET /location-types — the closed set of places a customer can say their
// station will be used. Authenticated but not admin-only.
//
// The list is what makes the prospect's location type editable safely: prospect
// responses carry the LABEL while writes expect the VALUE, and the backend
// silently discards a value it cannot parse. See useLocationTypes.
export const listLocationTypes = async (): Promise<LocationTypeOption[]> => {
  const response = await accountApi.get("location-types");
  return response.data?.location_types ?? [];
};
